import { Stack } from "@mui/material";
import { DKGridColumn } from "./DKGridColumn";
import React, { PropsWithChildren } from "react";
import { DKGridTitle } from "./DKGridTitle";

type DKGridFooterColumnProps = {
  dataTestId?: string;
  width: number;
  title: string;
  color?: string;
};

export const DKGridFooterColumn = (
  props: PropsWithChildren<DKGridFooterColumnProps>
) => {
  const { dataTestId, width, title, color } = props;

  return (
    <DKGridColumn width={width}>
      <Stack>
        <DKGridTitle title={title} color={color} dataTestId={dataTestId} />
        {props.children}
      </Stack>
    </DKGridColumn>
  );
};
